import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { postAxios } from "../../../Services/commonService";
import { API_SPORT } from "../../../../utils/api/ApiConstant";
import { Button, Error, Label } from "../..";
import SportSchema from "../../../Schema/Game/SportSchema";
import { uiActions } from "../../../../store/ui/ui-slice";
import { lowerFirstLetterUsingRegex } from "../../../helper/common";
import {
  sanitizeNameInput,
  sanitizePositiveNumberInput,
} from "../../../../utils/inputUtils";

const SportModal = ({ handleModalHide, rowData, fetchData }) => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      id: "",
      name: "",
      displayOrder: "",
    },
    resolver: yupResolver(SportSchema),
  });

  const onSubmit = async (values) => {
    const payload = {
      id: values?.id,
      name: values?.name,
      displayOrder: Number(values?.displayOrder),
    };
    const res = await postAxios(API_SPORT, payload);
    if (res?.success) {
      fetchData();
      handleModalHide();
    }
    res?.errors?.forEach((element) => {
      const field = lowerFirstLetterUsingRegex(element?.field);
      if (field)
        setError(field, {
          type: "manual",
          message: element.message,
        });
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <fieldset disabled={isSubmitting}>
        <div className="row ">
          <div className=" col-lg-6 col-12">
            <div className="form-group">
              <Label htmlFor="id" className="form-label" isRequired={true}>
                Id
              </Label>
              <input
                type="text"
                className={`form-control ${errors.id ? "is-invalid" : ""}`}
                id="id"
                placeholder="Enter Id"
                autoFocus={true}
                tabIndex={1}
                {...register("id", {
                  onChange: (e) => {
                    e.target.value = sanitizePositiveNumberInput(
                      e.target.value,
                    );
                  },
                })}
              />
              {errors.id && <Error>{errors.id.message}</Error>}
            </div>
          </div>
          {/* Sport Name */}
          <div className=" col-lg-6 col-12">
            <div className="form-group">
              <Label htmlFor="name" className="form-label" isRequired={true}>
                Sport name
              </Label>
              <input
                type="text"
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                id="name"
                placeholder="Enter sport name"
                {...register("name", {
                  onChange: (e) => {
                    e.target.value = sanitizeNameInput(e.target.value);
                  },
                })}
                tabIndex={2}
              />
              {errors.name && <Error>{errors.name.message}</Error>}
            </div>
          </div>

          <div className=" col-lg-6 col-12 ">
            <div className="form-group">
              <Label
                htmlFor="displayOrder"
                className="form-label"
                isRequired={true}
              >
                Display Order
              </Label>
              <input
                type="text"
                className={`form-control ${errors.displayOrder ? "is-invalid" : ""}`}
                id="displayOrder"
                placeholder="Enter Display Order"
                {...register("displayOrder", {
                  onChange: (e) => {
                    e.target.value = sanitizePositiveNumberInput(
                      e.target.value,
                    );
                  },
                })}
                tabIndex={3}
              />
              {errors.displayOrder && (
                <Error>{errors.displayOrder.message}</Error>
              )}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end w-100 mt-3">
          <Button
            type="button"
            className="btn btn_main btn_muted px-3 py-2 mx-1"
            onClick={handleModalHide}
            tabIndex={5}
          >
            Close
          </Button>
          <Button
            type="submit"
            className="btn btn_main px-3 py-2 mx-1"
            tabIndex={4}
            isDisabled={isSubmitting}
          >
            {isSubmitting ? "Loading.." : "Submit"}
          </Button>
        </div>
      </fieldset>
    </form>
  );
};

export default SportModal;
